import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  ButtonGroup,
  Input,
  Label,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {
  getLocalStorageData,
  displayDateV1,
  convertDateFormate,
  getDateByName,
  getPercentageWithAlertV1,
  currencyFormatWithoutDecimalV1,
} from "../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";

const CaptureRateOccupancy = ({ captureRateOcc, loading }) => {
  // const series = [
  //     {
  //     data: [
  //         [65, 48], // [Occupancy %, Capture Rate %]
  //         [75, 53],
  //         [85, 58],
  //     ],
  //     },
  // ];
  // Convert object to array of [date, [occupancy, captureRate]]
  const validData = Object.entries(captureRateOcc);

  //const index0Values = validData.map(([_, val]) => val[0]); // Occupancy values (X)
  const index1Values = validData.map(([_, val]) => val[1]); // Capture Rate values (Y)

  //const bufferX = (Math.max(...index0Values) - Math.min(...index0Values)) * 0.1;
  const bufferY = (Math.max(...index1Values) - Math.min(...index1Values)) * 0.1;

  // const minIndex0 = Math.max(0, Math.floor(Math.min(...index0Values) - bufferX));
  // const maxIndex0 = Math.ceil(Math.max(...index0Values) + bufferX);

  // const minIndex1 = Math.max(0, Math.floor(Math.min(...index1Values) - bufferY));
  const maxIndex1 = Math.ceil(Math.max(...index1Values) + bufferY);

  let YAXIS_MAX = 15;
  if (maxIndex1 > 15) {
    YAXIS_MAX = maxIndex1;
  }

  const rawData = captureRateOcc; // your API object
  const transformedData = Object.entries(rawData)
    // .filter(([_, val]) => val[0] !== 0 && val[1] !== 0) // filter out [0, 0] points
    .map(([date, [occupancy, captureRate]]) => ({
      x: occupancy,
      y: captureRate,
      date: date,
    }));

  const series = [
    {
      data: transformedData,
    },
  ];

  const options = {
    chart: {
      type: "scatter",
      zoom: { enabled: true },
      toolbar: { show: true },
    },
    xaxis: {
      min: 0,
      max: 100,
      tickAmount: 10,
      labels: {
        style: { colors: "#000", fontSize: "14px" },
        formatter: (val) => `${Math.round(val)}%`,
      },
    },
    yaxis: {
      min: 0,
      max: YAXIS_MAX,
      tickAmount: 5,
      labels: {
        style: { colors: "#000", fontSize: "14px" },
        formatter: (val) => `${Math.round(val)}%`,
      },
    },
    markers: {
      size: 5,
      colors: ["#4ECDC4"],
      strokeWidth: 1,
      hover: { sizeOffset: 3 },
    },
    // tooltip: {
    //     custom: function({ series, seriesIndex, dataPointIndex, w }) {
    //     const [x, y] = w.config.series[seriesIndex].data[dataPointIndex];
    //     return `<div style="padding:5px">
    //                 Occupancy: ${x}%<br/>
    //                 Capture Rate: ${y}%
    //             </div>`;
    //     },
    // },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const point = w.config.series[seriesIndex].data[dataPointIndex];
        return `<div style="padding:5px">
                    <strong>${point.date}</strong><br/>
                    Occupancy: ${point.x}%<br/>
                    Capture Rate: ${point.y}%
                    </div>`;
      },
    },
  };
  return (
    <Col sm={12} lg={12}>
      <Card className="px-3" style={{ minHeight: "470px" }}>
        <CardHeader className="ps-0 border-0 align-items-center">
          <div className="d-flex align-items-start">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-line-chart-fill"></i>
            </div>
            <div className="ps-2">
              <h4 className="card-title mb-0 flex-grow-1">
                Capture Rate vs. Occupancy
              </h4>
              <p>
                Correlation between hotel occupancy levels and restaurant capture
                rates
              </p>
            </div>

          </div>
        </CardHeader>
        <CardBody className="p-0">
          {loading && <Loader />}
          <div className={loading ? "opacity-0" : ""}>
            <ReactApexChart
              options={options}
              series={series}
              type="scatter"
              height={350}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CaptureRateOccupancy;
